import { useEffect, useRef } from "react";

export default function PreviewModal({ open, onClose }) {
  const dialogRef = useRef(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;

    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);

  // optional: Body scroll sperren, wenn offen (sehr empfehlenswert auf Mobile)
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  return (
    <dialog
      id="previewModal"
      ref={dialogRef}
      className="preview-modal"
      aria-label="Kursvorschau"
      onCancel={(e) => {
        e.preventDefault();
        onClose?.();
      }}
    >
      <div className="modal-head">
        <h3>Vorschau: Was erwartet dich?</h3>
        <button className="x" aria-label="Schließen" onClick={onClose}>
          ×
        </button>
      </div>

      <div className="video-wrap">
        {open && (
          <iframe
            src="https://drive.google.com/file/d/1T9r7fabmRrClGd9iqwMJ92iSL3-kJ1Co/preview"
            title="Kursvorschau"
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
        )}
      </div>
    </dialog>
  );
}
